import keyMirror from 'keymirror';

const Constants = keyMirror({
  TeamDash: null,
  TeamDashEventList: null,
  TeamDashGlobalElementsList: null,
  UserDash: null,
  UserDashEventList: null,
  EventDash: null,
  EventCrew: null,
  EventSettings: null,
});

export default Constants;

export const TeamDash = Constants.TeamDash;
export const TeamDashEventList = Constants.TeamDashEventList;
export const TeamDashGlobalElementsList = Constants.TeamDashGlobalElementsList;
export const UserDash = Constants.UserDash;
export const UserDashEventList = Constants.UserDashEventList;
export const EventDash = Constants.EventDash;
export const EventCrew = Constants.EventCrew;
export const EventSettings = Constants.EventSettings;
